import type { Theme } from "@mui/material/styles";

/**
 * The shared canvas-pill surface every floating viewport control sits on:
 * white card, hairline border, low shadow. Exported so controls that live in
 * their own file (e.g. the regenerate button) stay pixel-identical.
 */
export const ruleGraphCanvasControlSx =
  (disabled: boolean) => (theme: Theme) => ({
    alignItems: "center",
    backgroundColor: theme.igBackgroundColors.baseLightHigh,
    border: `1px solid ${theme.igBorders.core.default}`,
    // Figma `border radius/lg`; the pill's hairline border is inside the
    // Figma-specified 113x30 box, so it must not grow the control.
    borderRadius: "8px",
    boxShadow: theme.igShadows.low,
    boxSizing: "border-box",
    color: theme.palette.text.primary,
    cursor: disabled ? "not-allowed" : "pointer",
    display: "flex",
    font: "inherit",
    justifyContent: "center",
    opacity: disabled ? 0.5 : 1,
    padding: 0,
    transition: "background-color 120ms ease, border-color 120ms ease",
    "&:hover:not(:disabled)": {
      borderColor: theme.igBorders.core.hover,
    },
    "&:focus-visible": {
      outline: `2px solid ${theme.palette.text.interactive.neutral.default}`,
      outlineOffset: 2,
    },
  });
